// Version : 1.0.0
// Author : AGALYA

import { API_URL } from '../../const';

// Arrange Member Tab
export const arrageMemberTab = (dataArr: any, loginData: any) => {
	const arrCopy = dataArr;
	const { databaseName } = loginData;
	arrCopy.map((item: any) => {
		if (parseFloat(loginData.ISHighMarkCheck) === 1 && item.label === 'Credit Check') {
			item.isShow = true;
		} else if (parseFloat(loginData.ISHighMarkCheck) === 0 && item.label === 'Credit Check') {
			item.isShow = false;
		}

		if (item.label === 'Other Details') {
			if (databaseName === 'Nagas' || databaseName === 'RollBack') {
				item.isShow = true;
			} else {
				item.isShow = false;
			}
		}

		if (item.label === 'Business Information') {
			if (databaseName === 'Nagas' || databaseName === 'RollBack') {
				item.isShow = true;
			} else {
				item.isShow = false;
			}
		}
	});
	return arrCopy;
};

// Update Member Tab
export const updateMemberTab = (dataArr: any, tabName: any) => {
	const arrCopy = dataArr;
	const currentIndex = arrCopy.findIndex((x: any) => x.label === tabName);

	if (tabName === 'RESET') {
		arrCopy.map((item: any, index: any) => {
			if (index === 0) {
				item.isDisable = false;
				item.isCompleted = false;
			} else {
				item.isDisable = true;
				item.isCompleted = false;
			}
		});
	} else if (tabName === 'Completed') {
		arrCopy.map((item: any) => {
			item.isDisable = false;
			item.isCompleted = true;
		});
	} else {
		arrCopy.map((item: any, index: any) => {
			if (index <= currentIndex) {
				item.isDisable = false;
				if (index < currentIndex && !item.isCompleted) {
					item.isCompleted = true;
				}
			} else if (!item.isCompleted) {
				item.isDisable = true;
				item.isCompleted = false;
			}
			if (item.label === 'Member KYC') {
				item.isDisable = false;
			}
		});
	}

	return arrCopy;
};

// Next Navigate Page
export const nextNavigatePage = (memberDetails: any, databaseName?: string) => {
	let navigationPage = '';
	const stageStatus = parseInt(
		memberDetails?.StageCompleted !== undefined ? memberDetails.StageCompleted : 1,
	);

	if (stageStatus === 1 || stageStatus === 2) {
		navigationPage = 'Basic Details';
	} else if (stageStatus === 3) {
		navigationPage = 'Personal Details';
	} else if (stageStatus === 4 || stageStatus === 5) {
		navigationPage = 'Personal Details';
	} else if (stageStatus === 6) {
		navigationPage = 'Family Details';
	} else if (stageStatus === 7) {
		navigationPage = 'Family Details';
	} else if (stageStatus === 8) {
		navigationPage = 'Nominee Details';
	} else if (stageStatus === 9) {
		navigationPage = 'Bank Details';
	} else if (stageStatus === 10) {
		navigationPage = 'House Details';
	} else if (stageStatus === 11 || stageStatus === 12 || stageStatus === 13) {
		navigationPage = 'Member Documents';
	} else if (stageStatus === 14) {
		navigationPage = 'Nominee Documents';
	} else if (stageStatus === 15 || stageStatus === 16) {
		navigationPage = 'Nominee Documents';
	} else if (stageStatus === 17) {
		navigationPage = 'House Images';
	} else if (stageStatus === 18) {
		navigationPage = 'House Images';
	} else if (stageStatus === 19) {
		navigationPage = 'Extra Information';
	} else if (stageStatus === 20) {
		navigationPage = 'Official Details';
	} else if (stageStatus === 21) {
		if (databaseName === 'Nagas' || databaseName === 'RollBack') {
			navigationPage = 'Other Details';
		} else {
			navigationPage = 'Co Applicant';
		}
	} else if (stageStatus === 22) {
		if (databaseName === 'Nagas' || databaseName === 'RollBack') {
			navigationPage = 'Business Information';
		} else {
			navigationPage = 'Co Applicant';
		}
	} else if (stageStatus === 23) {
		navigationPage = 'Co Applicant';
	} else if (stageStatus === 24) {
		navigationPage = 'Completed';
	} else {
		navigationPage = 'Verification';
	}

	if (
		stageStatus === 0 &&
		memberDetails?.IsHighMarkCheckNeeded !== undefined &&
		memberDetails?.IsHighMarkCheckNeeded === 1
	) {
		navigationPage = 'Credit Check';
	}

	return navigationPage;
};

// Check Family Details
export const checkFamilyDetails = (famArr: any, mandData: any) => {
	let missingData = '';
	const {
		FamilyMemberName,
		FamilyMemberGender,
		FamilyMemberAadhar,
		FamilyMemberAge,
		FamilyMemberRelationship,
		FamilyMemberEducation,
		FamilyMemberOccupation,
		FamilyMonthlyIncode,
	} = mandData;
	if (famArr !== undefined && famArr !== null && famArr !== '') {
		if (famArr.length > 0) {
			for (let i = 0; i < famArr.length; i += 1) {
				if (
					FamilyMemberName === '1' &&
					(famArr[i].FamilyMemberName === '' ||
						famArr[i].FamilyMemberName === null ||
						famArr[i].FamilyMemberName === undefined)
				) {
					missingData = 'Enter Family Member Name.';
					break;
				} else if (
					FamilyMemberGender === '1' &&
					(famArr[i].FamilyMemberGender === '' ||
						famArr[i].FamilyMemberGender === null ||
						famArr[i].FamilyMemberGender === undefined)
				) {
					missingData = `Select Family Member ${famArr[i].FamilyMemberName} Gender.`;
					break;
				} else if (
					FamilyMemberAadhar === '1' &&
					(famArr[i].FamilyMemberAadharNumber === '' ||
						famArr[i].FamilyMemberAadharNumber === null ||
						famArr[i].FamilyMemberAadharNumber === undefined)
				) {
					missingData = `Enter Family Member ${famArr[i].FamilyMemberName} Aadhar.`;
					break;
				} else if (
					FamilyMemberAge === '1' &&
					(famArr[i].FamilyMemberAge === '' ||
						famArr[i].FamilyMemberAge === null ||
						famArr[i].FamilyMemberAge === undefined)
				) {
					missingData = `Enter Family Member ${famArr[i].FamilyMemberName} Age.`;
					break;
				} else if (
					FamilyMemberRelationship === '1' &&
					(famArr[i].FamilyMemberRelationship === '' ||
						famArr[i].FamilyMemberRelationship === null ||
						famArr[i].FamilyMemberRelationship === undefined)
				) {
					missingData = `Select Family Member ${famArr[i].FamilyMemberName} Relationship.`;
					break;
				} else if (
					FamilyMemberEducation === '1' &&
					(famArr[i].education === '' ||
						famArr[i].education === null ||
						famArr[i].education === undefined)
				) {
					missingData = `Select Family Member ${famArr[i].FamilyMemberName} Education.`;
					break;
				} else if (
					FamilyMemberOccupation === '1' &&
					(famArr[i].occupation === '' ||
						famArr[i].occupation === null ||
						famArr[i].occupation === undefined)
				) {
					missingData = `Select Family Member ${famArr[i].FamilyMemberName} Education.`;
					break;
				} else if (
					FamilyMonthlyIncode === '1' &&
					(famArr[i].monthlyIncome === '' ||
						famArr[i].monthlyIncome === null ||
						famArr[i].monthlyIncome === undefined)
				) {
					missingData = `Enter Family Member ${famArr[i].FamilyMemberName} Income.`;
					break;
				}
			}
		}
	}
	return missingData;
};

// Max DOB Limit
export const maxDOBLimit = () => {
	const today = new Date();
	const maxDOB = new Date(today.getFullYear() - 19, today.getMonth(), today.getDate());
	return maxDOB.toISOString().split('T')[0]; // Returns a string in 'YYYY-MM-DD' format
};

// Till Today Limit
export const tillTodayLimit = () => {
	const today = new Date();
	return today.toISOString().split('T')[0]; // Returns a string in 'YYYY-MM-DD' format
};

// Export Member Function
export const excelExportMemberFunction = async (
	excelUrl: string,
	listData: any,
	excelToken: string,
) => {
	const url = `${API_URL}Excel/${excelUrl}.php`;
	const params = new URLSearchParams();
	params.append(excelToken, listData);

	const response = await fetch(url, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
		body: params.toString(),
	});

	const result = await response.json();

	if (result.status === 'success' && result.downloadURL) {
		// Trigger download
		const fullDownloadUrl = `${API_URL}Excel/${result.downloadURL}`;
		const link = document.createElement('a');
		link.href = fullDownloadUrl;
		link.download = result.filename;
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	} else {
		console.error('Export failed:', result);
	}
};
